import { Box, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link as LinkBase } from 'react-router-dom';

export const Wrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
`;

export const SettingWrapper = styled(LinkBase)``;

export const Link = styled(LinkBase)``;

export const Button = styled(IconButton)``;
